import { ListSubheader, MenuItem, Select } from '@mui/material';
import { graphql } from '../../gql';
import { useApiQuery } from '../../query/hooks';
import { ComponentProps, FC } from 'react';
import { LoadableSelect } from '../../form/LoadableSelect';
import { groupBy } from 'lodash';
import { FormattedMessage } from 'react-intl';

const listMetricTemplateQuery = graphql(`
	query connections_listMetricTemplate {
		listMetricTemplate {
			id
			name
			isSystem
		}
	}
`);

type Props = ComponentProps<typeof Select<string>> &
	Readonly<{
		loading?: boolean;
	}>;

const MetricTemplateSelect: FC<Props> = ({ placeholder, value, loading, ...props }) => {
	const { isLoading: areItemsLoading, data: itemsData } = useApiQuery(listMetricTemplateQuery);

	const { true: systemMetricTemplates = [], false: customMetricTemplates = [] } = groupBy(itemsData?.listMetricTemplate ?? [], 'isSystem');

	return (
		<LoadableSelect
			{...props}
			loading={loading || areItemsLoading}
			value={value ?? '' /* value cannot be undefined in order to keep the input controlled */}
		>
			{systemMetricTemplates.length > 0 && (
				<ListSubheader>
					<FormattedMessage id={'metric-template-select.subheader.system'} />
				</ListSubheader>
			)}
			{systemMetricTemplates
				.sort((a, b) => (a.name && b.name ? a.name.localeCompare(b.name) : 0))
				.map((metricTemplate) => (
					<MenuItem key={metricTemplate.id} value={metricTemplate.id} sx={{ pl: 4 }}>
						{metricTemplate.name}
					</MenuItem>
				))}
			{customMetricTemplates.length > 0 && (
				<ListSubheader>
					<FormattedMessage id={'metric-template-select.subheader.custom'} />
				</ListSubheader>
			)}
			{customMetricTemplates
				.sort((a, b) => (a.name && b.name ? a.name.localeCompare(b.name) : 0))
				.map((metricTemplate) => (
					<MenuItem key={metricTemplate.id} value={metricTemplate.id} sx={{ pl: 4 }}>
						{metricTemplate.name}
					</MenuItem>
				))}
		</LoadableSelect>
	);
};

export { MetricTemplateSelect };
